import React, { useEffect, useRef } from "react";
import { MOBILE_BREAKPOINT } from "../../../../../../constants/breakpoints";
import {
    MENU_DESKTOP_OFFSET,
    MENU_MOBILE_OFFSET,
    scrollIntoViewWithOffset,
} from "../../../../../utils/scrollIntoViewWithOffset";
import "./ScrollToComponent.less";
import { useViewport } from "../../../../checkout/hooks";

interface Props {
    children: React.ReactNode;
    id: string;
    scrollToOnOpen: boolean;
}

const ScrollToComponent: React.FC<Props> = ({ id, children, scrollToOnOpen }) => {
    const ref = useRef<HTMLDivElement>(null);
    const { width } = useViewport();
    const isMobile = width < MOBILE_BREAKPOINT;

    useEffect(() => {
        if (scrollToOnOpen) {
            scrollIntoViewWithOffset(`#${id}`, (isMobile ? MENU_MOBILE_OFFSET : MENU_DESKTOP_OFFSET) + 45);
        }
        // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
    }, [scrollToOnOpen]);

    return (
        <div ref={ref} className={"scroll-to-component"}>
            {children}
        </div>
    );
};

export default ScrollToComponent;
